import Button from '@shared/components/buttons';
import Modal from '@shared/components/modals';
import Textarea from '@shared/components/forms/form-components/inputs/text-area';
import { html } from '@shared/utils/rendering/html';
import { useState } from 'preact/hooks';

const ReopenEvidenceModal = ({ isVisible, closeModal, onConfirm, isSubmitting }) => {
    const [comment, setComment] = useState('');
    const isValid = comment.trim().length > 0;

    const handleConfirm = () => {
        if (!isValid || isSubmitting) return;
        onConfirm(comment.trim());
        setComment('');
    };

    const handleClose = () => {
        setComment('');
        closeModal();
    };

    const commentField = { name: 'reopen-comment', value: comment, setValue: setComment };

    return html`
        <${Modal}
            id="reopen-evidence-modal"
            header=${{ title: { text: 'Reopen Attestation' } }}
            footer=${html`
                <${Button}
                    buttonType="secondary"
                    label=${{ text: 'Cancel' }}
                    onClick=${handleClose}
                    disabled=${isSubmitting}
                />
                <${Button}
                    buttonType="primary"
                    label=${{ text: isSubmitting ? 'Reopening...' : 'Confirm Reopen' }}
                    onClick=${handleConfirm}
                    disabled=${!isValid || isSubmitting}
                />
            `}
            options=${{ isVisible, onCloseEvent: handleClose }}
        >
            <p class="fw-bold mb-3">
                The attestation will be reset to allow new evidence to be submitted. A reason is
                required.
            </p>

            <div class="form-group mt-2">
                <${Textarea}
                    field=${commentField}
                    label=${{ text: 'Reason for reopening' }}
                    id="reopen-comment"
                    rows="4"
                    maxLength=${3000}
                    placeholder="Enter a reason for reopening this attestation..."
                    required=${true}
                    disabled=${isSubmitting}
                />
            </div>
        </${Modal}>
    `;
};

export default ReopenEvidenceModal;
